<script>
import GoalIndicator from '@companies/components/goal-indicator.vue'

export default {
  name: 'UserHeader',
  components: {
    GoalIndicator,
  },
  props: { user: { type: Object, required: true } },
  computed: {
    goalFontSize() {
      let maxLength = 0
      let fontSize = 'text-4.5xl'
      for (var i = this.user.my_goals.length - 1; i >= 0; i--) {
        if (this.user.my_goals[i].achieved.toString().length > maxLength) {
          maxLength = this.user.my_goals[i].achieved.toString().length
        }
      }
      if (maxLength > 4) {
        fontSize = 'text-3xl'
      }
      return fontSize
    },
  },
}
</script>

<template>
  <div class="bg-white">
    <div id="hub_background" class="">
      <img :src="user.background_url" />
    </div>
    <div class="-mt-30 h-58 pl-15 pr-20 flex justify-between">
      <div
        class="w-58 h-58 bg-white rounded-full overflow-hidden shadow-input flex items-center justify-center"
      >
        <img :src="user.image_url" />
      </div>
      <div class="mt-5 flex">
        <GoalIndicator
          v-for="goal in user.my_goals"
          :key="goal.type"
          :goal="goal"
          :font-size="goalFontSize"
        ></GoalIndicator>
      </div>
    </div>
    <div class="pl-15 mt-8 pb-20 text-5.5xl text-blue-darker">
      {{ user.name }}
    </div>
  </div>
</template>
